<div class="container">
  <div class="header">
    <h3>{{ data.title }}</h3>
    <button class="close" (click)="onCancel()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="message">
    @if (data.messageHtml) {
      <p [innerHTML]="data.messageHtml"></p>
    } @else {
      <p>{{ data.message }}</p>
    }
  </div>

  <div class="btn-group">
    <app-button buttonVariant="compact-secondary" buttonType="button" (buttonClick)="onCancel()">
      {{ data.cancelText || 'Cancel' }}
    </app-button>
    <app-button buttonVariant="compact-primary" buttonType="button" (buttonClick)="onConfirm()">
      {{ data.confirmText || 'Confirm' }}
    </app-button>
  </div>
</div>
